<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title" style="position: relative;">
            {{title}} 
            <el-tag type="success">红包余额:{{account}} </el-tag> 
            <span style="float:right;"><el-button type="success" size="mini" @click="handleWithdrawal()">申请提现</el-button></span>
        </div>
        <div class="user_content_blcok_line"></div>

        <div class="admin_table_main">
                <el-table :data="list">
                  <el-table-column label="ID" prop="id" width="70px"><template slot-scope="scope">{{scope.row.id}}</template></el-table-column>
                  <el-table-column label="日期"><template slot-scope="scope">{{scope.row.rq | formatTime}}</template></el-table-column>
                  <el-table-column label="类别" width="130px" prop="rechargeName">
                      <template slot-scope="scope">{{scope.row.rechargeName}}</template></el-table-column>
                    <el-table-column label="金额" width="120px" prop="cash">
                        <template slot-scope="scope">
                            <div v-if="scope.row.cash>0"><el-tag type="danger">+{{scope.row.cash}}</el-tag></div>
                            <div v-if="scope.row.cash==0"><el-tag>{{scope.row.cash}}</el-tag></div>
                            <div v-if="scope.row.cash<0"><el-tag type="info">{{scope.row.cash}}</el-tag></div>
                        </template> 
                    </el-table-column>
                    <el-table-column label="状态" width="120px" prop="money">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status==0"><el-tag type="warning">待审核</el-tag></div>
                            <div v-if="scope.row.status==1"><el-tag type="success">已审核</el-tag></div>
                            <div v-if="scope.row.status==2"><el-tag type="danger">已拒绝</el-tag></div>
                        </template> 
                    </el-table-column>
                </el-table>
                <div class="home_fy_block" style="margin-top:40px;" >
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total" :page-size="pageSize" :current-page="pageNum"></el-pagination>
                </div>
            </div>


    <el-dialog
      title="红包提现"
      :visible.sync="dialogVisible"
      width="40%">
            <el-form ref="moneyform" :rules="rules"  :model="change_info" label-width="150px" size="small">
                <el-form-item label="可用金额：">
                    <el-input disabled v-model="account"></el-input>
                </el-form-item>
                <el-form-item label="提现金额：" prop="cash">
                  <el-input-number size="small" :precision="2" v-model="change_info.cash" :max="account"></el-input-number>
                </el-form-item>
            </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="getWithdrawal()">确 定</el-button>
      </span>
    </el-dialog>



    </div>

</template>

<script>
import {formatDate} from '@/utils/date';
export default {
    components: {},
    props: {},
    data() {
      return {
          list:[],
          total:0, // 总条数
          pageSize:20,
          pageNum:1,
          select_id:'',
          title:'我的红包',
          account:0,
          dialogVisible:false,
          change_info:{
              cash:1
          },
      };
    },
    watch: {
        
    },
    filters: {
      formatDateTime(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      }, 
    },
    computed: {},
    methods: {
        handleSelectionChange:function(e){
            let ids = [];
            e.forEach(v => {
                ids.push(v.id);
            });
            this.select_id = ids.join(',');
        },
        get_money_log:function(){
            this.$get(this.$api.HongBaoReceiveDetailByUser,{pageSize:this.pageSize,pageNum:this.pageNum,platId:this.$platId}).then(res=>{
                this.list = res.data.list;
                this.total = res.data.total;
                if(res.data.list[0].account){
                this.account = res.data.list[0].account;
                }
            })
        },
        getWithdrawal:function(){
            this.$get(this.$api.getHongbao,{money:'10'}).then(res=>{
                if(res.code == 200){
                    this.$message.success(res.data.return_msg);
                    this.get_money_log();
                    this.dialogVisible = false;
                }else{
                    this.$message.error(res.message);
                }
            })
        },
        handleWithdrawal:function(){
            if(this.account > 0){
                this.dialogVisible = true;
                this.change_info.cash = this.account;
            }else{
                this.$message.error('不可提现!');
            }

        },
        
        current_change:function(e){
            this.pageNum = e;
            this.get_money_log();
            this.$scrollTo();
        },
    },
    created() {
        this.get_money_log();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.red{
    color:#409EFF;
}
.green{
    color:#42b983;
}

</style>